import produce from 'immer';
import * as _ from 'lodash';

import { getGroupedIndex } from '../../components/raw_vulns/RawVulnUtils';
import { errorMessageFromResponse } from '../../helpers/errors';
import { createReducer } from '../utils';

import type { RawVulnsStore } from './store';

const getInitialState = (): RawVulnsStore => ({
  vulns: {},
  totalCount: 0,
  status: {
    loading: false,
    error: null,
  },
});

const rawVulnReducer = createReducer(getInitialState(), {
  FETCH_ALL_RAW_VULNS_PENDING: (state) => produce(state, draftState => {
    draftState.status.loading = true;
    draftState.status.error = null;
  }),
  FETCH_ALL_RAW_VULNS_FULFILLED: (state, action) => produce(state, draftState => {
    if (action.payload.data) {
      const { items, totalCount } = action.payload.data;
      draftState.totalCount = totalCount;
      draftState.vulns = items;
    }
    draftState.status.loading = false;
    draftState.status.error = null;
  }),
  FETCH_ALL_RAW_VULNS_REJECTED: (state, action) => produce(state, draftState => {
    draftState.status.loading = false;
    draftState.status.error = errorMessageFromResponse(action.payload);
  }),
  UPDATE_RAW_VULNS_PENDING: (state) => produce(state, draftState => {
    draftState.status.loading = true;
    draftState.status.error = null;
  }),
  UPDATE_RAW_VULNS_FULFILLED: (state, action) => produce(state, draftState => {
    draftState.status.loading = false;
    draftState.status.error = null;

    const groupedUpdatedVulns = _.groupBy(
      action.meta.vulns,
      (vuln) => getGroupedIndex(vuln.cve, vuln.projectName, vuln.fetcher),
    );

    draftState.vulns = _.mapValues(
      draftState.vulns,
      (vuln) => {
        const { cve, projectName, fetcher } = _.head(vuln);
        return groupedUpdatedVulns[getGroupedIndex(cve, projectName, fetcher)] || vuln;
      },
    );
  }),
  UPDATE_RAW_VULNS_REJECTED: (state, action) => produce(state, draftState => {
    draftState.status.loading = false;
    draftState.status.error = errorMessageFromResponse(action.payload);
  }),
});

export default rawVulnReducer;
